{% block sw_cms_element_acris_blog_product_slider %}
    <div
            class="sw-cms-el-acris-blog-product-slider"
            :class="classes"
            :style="verticalAlignStyle"
    >

        {% block sw_cms_element_acris_blog_product_slider_content %}
            <div class="sw-cms-el-acris-blog-product-slider__content">
                {% block sw_cms_element_acris_blog_product_slider_arrow_left %}
                    <div
                            v-if="hasNavigationArrows"
                            class="sw-cms-el-acris-blog-product-slider__navigation is--left-arrow"
                    >
                        <mt-icon
                                class="sw-cms-el-acris-blog-product-slider__navigation-button"
                                name="regular-chevron-left"
                                size="24"
                        />
                    </div>
                {% endblock %}

                {% block sw_cms_element_acris_blog_product_slider_product_holder %}
                    <div
                            ref="productHolder"
                            class="sw-cms-el-acris-blog-product-slider__product-holder"
                            :style="sliderBoxMinWidth"
                    >
                        {% block sw_cms_element_acris_blog_product_slider_demo_data %}
                            <sw-cms-el-product-box
                                    v-for="index in sliderBoxLimit"
                                    :key="index"
                                    :element="demoProductElement"
                            />
                        {% endblock %}
                    </div>
                {% endblock %}

                {% block sw_cms_element_acris_blog_product_slider_arrow_right %}
                    <div
                            v-if="hasNavigationArrows"
                            class="sw-cms-el-acris-blog-product-slider__navigation is--right-arrow"
                    >
                        <mt-icon
                                class="sw-cms-el-acris-blog-product-slider__navigation-button"
                                name="regular-chevron-right"
                                size="24"
                        />
                    </div>
                {% endblock %}
            </div>
        {% endblock %}
    </div>
{% endblock %}
